/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.firealarm.rpc.alarms.FireAlarmReadRpc
 */

export const getAlarmsRpc = {
  serviceName: 'com.hubspot.firealarm.rpc.alarms.FireAlarmReadRpc',
  rpcName: 'getAlarms',
  auth: 'app',
  fingerprint: 'rkkrZ2Xd-CXOGvnFqGsLZobwvblExsZh',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};